import Select from "react-select";
import constant from "../../../../constants.js";
import AlertContext from "../../../../context/AlertContext.js";
import React, { useState, useEffect, useContext } from "react";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate.js";
import ModulesHooks from "../../../../Hooks/Question/ModulesHooks.js";
import { LibraryContext } from "../../../../context/LibraryContext.js";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks.js";
import CodingQuestionEntryHooks from "../CodingQuestionEntry/Hooks/CodingQuestionEntryHooks.js";

const customStylesForTopic = {
  control: (base, state) => ({
    ...base,
    marginTop: "20px",
    border: "1px solid #BDC1C6",
    maxHeight: "40px !important",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      width: "370px",
      height: "36px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      background: "white",
      fontFamily: "Inter",
      color: isSelected ? "#000000" : undefined,
      ":hover": {
        color: "white",
        width: "370px",
        backgroundColor: "#0d6efd",
      },
    };
  },
  singleValue: (styles, { data }) => ({
    ...styles,
    color: "#202124",
    fontSize: "14px",
    fontWeight: "400",
    textAlign: "left",
    lineHeight: "20px",
    fontStyle: "normal",
    fontFamily: "Inter",
    paddingLeft: "10px",
    borderRadius: "20px",
  }),
  menuList: (base) => ({
    ...base,
    textAlign: "left",
    maxHeight: "150px",
    overflowX: "hidden",
    borderRadius: "2px",
  }),
};

export default function Complexity() {
  const Alert = useContext(AlertContext);
  const LibraryCxt = useContext(LibraryContext);

  const axios = useAxiosPrivate();
  const ModulesHks = ModulesHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();

  const [ComplexityData, setComplexityData] = useState([]);
  const [changingLevel, setChangingLevel] = useState(true);
  const [complexityValue, setComplexityValue] = useState("");
  const [fromEditQuestion, setFromEditQuestion] = useState(false);

  const handleChange = (event, name) => {
    LibraryCxt.setIsSelectedComplexity(false);
    setChangingLevel(false);
    setComplexityValue(event);

    ModulesHks.handleInputChange(event, name);
  };

  if (
    Alert.isqueReport &&
    LibraryCxt.isSelectedComplexity &&
    Alert.tableShowStatus !== constant.libTypeIds.MCQ &&
    Alert.tableShowStatus !== constant.libTypeIds.DESCRIPTIVE &&
    Alert.tableShowStatus !== constant.libTypeIds.CODING_CHALLENGE &&
    Alert.tableShowStatus !== constant.libTypeIds.CODING_SNIPPET
  ) {
    LibraryCxt.setAlreadySelectedCom(null);
  }

  useEffect(() => {
    if (
      LibraryCxt.handleadd &&
      (Alert.tableShowStatus === constant.libTypeIds.MCQ ||
        Alert.tableShowStatus === constant.libTypeIds.DESCRIPTIVE ||
        Alert.tableShowStatus === constant.libTypeIds.CODING_SNIPPET ||
        Alert.tableShowStatus === constant.libTypeIds.CODING_CHALLENGE)
    ) {
      setComplexityValue("");
      LibraryCxt.setLevel(null);
    }
  }, [LibraryCxt.handleadd, Alert.tableShowStatus]);

  useEffect(() => {
    axios
      .get(
        "node/admin/complexity/get",
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        let json = res.data;

        let newcomplexity = json.map((comp) => {
          return {
            value: comp.id,
            label: comp.name,
          };
        });

        setComplexityData(newcomplexity);
        LibraryCxt.setComplexities(newcomplexity);
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      });

    setFromEditQuestion(Alert.isqueReport);
  }, []);

  return (
    <div className="complexityMainContainer">
      <label htmlFor="levels">Level</label>

      <Select
        name="complexity"
        value={complexityValue}
        options={ComplexityData}
        classNamePrefix="select"
        styles={customStylesForTopic}
        className="questionComplexitySelect"
        onChange={(e) => handleChange(e, "complexity")}
        components={{ IndicatorSeparator: () => null }}
      />
    </div>
  );
}
